import { state } from './state';
import { els } from './ui';
import { updateConnectionIndicator } from '../uiHelpers';

interface SyncIndicatorState {
  delayTimer: number | null;
  showSync: boolean;
}

const syncIndicatorState: SyncIndicatorState = {
  delayTimer: null,
  showSync: false,
};

import type { ApiConfig } from './api';

export function scheduleSyncIndicatorReveal(
  applyModeBannerCallback: (cfg: ApiConfig) => void,
  cfg: ApiConfig
): void {
  if (!state) return;
  if (syncIndicatorState.delayTimer) {
    clearTimeout(syncIndicatorState.delayTimer);
  }
  syncIndicatorState.showSync = false;
  syncIndicatorState.delayTimer = window.setTimeout(() => {
    syncIndicatorState.delayTimer = null;
    if (state && state.isFetchingRemote && !state.remoteError) {
      syncIndicatorState.showSync = true;
      applyModeBannerCallback(cfg);
    }
  }, 1000);
}

export function clearSyncIndicatorDelay() {
  if (syncIndicatorState.delayTimer) {
    clearTimeout(syncIndicatorState.delayTimer);
    syncIndicatorState.delayTimer = null;
  }
  syncIndicatorState.showSync = false;
}

export function applyModeBanner(cfg: ApiConfig): void {
  if (!state || !cfg) return;
  const auth0Domain =
    cfg && typeof cfg === 'object' && 'auth0Domain' in cfg ? cfg.auth0Domain : undefined;
  const auth0ClientId =
    cfg && typeof cfg === 'object' && 'auth0ClientId' in cfg ? cfg.auth0ClientId : undefined;
  const hasAuth0 = !!(auth0Domain && auth0ClientId);
  if (els.refreshRemote) {
    els.refreshRemote.hidden = !(state.mode === 'auth0' && hasAuth0);
  }
  if (!els.modeBanner) return;
  if (!hasAuth0) {
    updateConnectionIndicator(
      els,
      'local',
      'Local mode',
      'Auth0 not configured. Running in local mode with favorites saved on this device.'
    );
    return;
  }
  if (state.mode === 'local') {
    updateConnectionIndicator(
      els,
      'local',
      'Local mode',
      'Local mode active. Data and favorites stay in this browser only.'
    );
    return;
  }
  if (state.remoteError) {
    updateConnectionIndicator(
      els,
      'error',
      'Offline',
      `API error: ${state.remoteError} — showing last known data. Use Refresh to retry.`
    );
  } else if (state.isFetchingRemote && syncIndicatorState.showSync) {
    updateConnectionIndicator(els, 'sync', 'Syncing…', 'Loading lots from LotLingo API...');
  } else {
    updateConnectionIndicator(
      els,
      'online',
      'Connected',
      'Connected to LotLingo. Lots and favorites sync automatically while this tab is visible.'
    );
  }
}
